import { ClassificaVO } from "./classificaVO";
import { UtenteVO } from "./utenteVO";
import { VisibilitaFascicoloVO } from "./visibilita-fascicoloVO";
import { RiferimentiPosizioneVO } from "./riferimenti-posizioneVO";
import { TipoIstanzaFascicoloVO } from "./tipo-istanza-fascicoloVO";
import { SettoreVO } from "./settoreVO";

export class WrapperCollegamentoFascicoloVO {
  id: string;

  tipologia: TipoIstanzaFascicoloVO;

  oggetto: string;

  segnaturaArchivistica: string;

  stato: string;

  classifica: ClassificaVO;

  dataApertura: string;

  inseritoDa: UtenteVO;

  visibilitaElemento: VisibilitaFascicoloVO[];

  strutturaResponsabile: SettoreVO;

  riferimentoPosizione: RiferimentiPosizioneVO;

  segnatura: string;

  visibilitaFascicolo: VisibilitaFascicoloVO[];
}
